import { useMainKeyVisualAndKeyVisuals } from "@/components/features/_hooks/use-main-kv-and-kvs";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomKeyVisual = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { mainKeyVisual, keyVisuals } = viewModel;

	return useMainKeyVisualAndKeyVisuals({
		mainKeyVisual,
		keyVisuals,
		onSetMainKeyVisual: onSetViewModel,
		onSetKeyVisuals: onSetViewModel,
	});
};
